"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAthenaQueries = exports.validateAthenaQuery = exports.staticValidateQuery = exports.filterUnauthorizedDatalakeTableNames = exports.filterDatalakeTables = exports.isFinleyAthenaTable = exports.extractTableNamesFromQuery = exports.extractTableNamesFromKnownPrefixes = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const construct_1 = require("../construct");
const utils = __importStar(require("../utils"));
const extractTableNamesFromQueryWithRegex = (queryString) => {
    const tables = new Set();
    // Match after FROM or JOIN — allow quoted identifiers and dot chains
    const regex = /\b(?:FROM|JOIN)\s+((?:"[^"]+"|\w+)(?:\.(?:"[^"]+"|\w+))*)/gi;
    let matches = regex.exec(queryString);
    // eslint-disable-next-line no-restricted-syntax
    while (matches !== null) {
        const fullReference = matches[1]; // e.g., `"finleydb"."athena_views"."some_table"` or `simple_table`
        // Clean off outer quotes
        const cleaned = fullReference.replace(/"/g, '');
        // If no dot, it's a standalone table
        if (!cleaned.includes('.')) {
            tables.add(cleaned);
        }
        matches = regex.exec(queryString);
    }
    return Array.from(tables);
};
const extractViewNamesFromQueryWithRegex = (queryString) => {
    const tables = new Set();
    const regex = /"?finleydb"?\."?athena_views"?\."?([\w]+)"?/gi;
    let matches = regex.exec(queryString);
    // eslint-disable-next-line no-restricted-syntax
    while (matches !== null) {
        tables.add(matches[1].replace(/[`"'[\]]/g, ''));
        matches = regex.exec(queryString);
    }
    return Array.from(tables);
};
// export for testing purposes
const extractTableNamesFromKnownPrefixes = (queryString) => {
    const tables = new Set();
    finley_types_1.DataLake.ALL_TABLE_PREFIXES.forEach((prefix) => {
        // Match the prefix followed by _ and then valid table name characters.
        const regex = new RegExp(`\\b(${prefix}_[a-zA-Z0-9_]+)`, 'ig');
        const matches = queryString.matchAll(regex);
        for (const match of matches) {
            tables.add(match[1]);
        }
    });
    return Array.from(tables);
};
exports.extractTableNamesFromKnownPrefixes = extractTableNamesFromKnownPrefixes;
/**
 * Note that this only focuses on read-only SQL queries, as these are
 * the only commands that Athena supports. Thus, only checking for
 * "from" and "join" and not "create table", "update", etc.
 */
const extractTableNamesFromQuery = (queryString) => {
    // we attempt to identify known tables from a few different angles
    // looking for known identifiers(extractViewNamesFromQueryWithRegex, extractTableNamesFromKnownPrefixes)
    // looking for join and select statements and parsing out the relations they mention
    const viewNames = extractViewNamesFromQueryWithRegex(queryString);
    const tableNames = extractTableNamesFromQueryWithRegex(queryString);
    const knownPrefixTablesNames = (0, exports.extractTableNamesFromKnownPrefixes)(queryString);
    const tables = new Set([
        ...viewNames,
        ...tableNames,
        ...knownPrefixTablesNames,
    ]);
    return Array.from(tables);
};
exports.extractTableNamesFromQuery = extractTableNamesFromQuery;
const isFinleyAthenaTable = (tableName) => {
    return finley_types_1.DataLake.ALL_TABLE_PREFIXES.some((prefix) => tableName.startsWith(prefix));
};
exports.isFinleyAthenaTable = isFinleyAthenaTable;
const filterDatalakeTables = (tables) => tables.filter((table) => (0, exports.isFinleyAthenaTable)(table));
exports.filterDatalakeTables = filterDatalakeTables;
const _filterUnauthorizedDatalakeTableNames = ({ authorizedTableNames, requestedTableNames, }) => {
    const authorizedTableNameSet = new Set(authorizedTableNames);
    // ignore non-datalake requested tables
    const requestedDatalakeTableNames = (0, exports.filterDatalakeTables)(requestedTableNames);
    const unauthorizedDatalakeTableNameSet = new Set();
    requestedDatalakeTableNames.forEach((tableName) => {
        if (!authorizedTableNameSet.has(tableName)) {
            unauthorizedDatalakeTableNameSet.add(tableName);
        }
    });
    return Array.from(unauthorizedDatalakeTableNameSet);
};
const extractTableNamesFromQueryStrings = (queryStrings) => {
    const requestedTableNameSet = new Set();
    queryStrings.forEach((qs) => {
        // this extracts ALL table name, not just datalake
        const tableNames = (0, exports.extractTableNamesFromQuery)(qs);
        tableNames.forEach((tn) => {
            requestedTableNameSet.add(tn);
        });
    });
    return Array.from(requestedTableNameSet);
};
const filterUnauthorizedDatalakeTableNames = ({ authorizedTableNames, queryStrings, explicitlyRequestedTableNames, }) => {
    const requestedTableNamesFromQueryStrings = extractTableNamesFromQueryStrings(queryStrings);
    const requestedTableNames = [
        ...explicitlyRequestedTableNames,
        ...requestedTableNamesFromQueryStrings,
    ];
    const unauthorizedDatalakeTableNames = _filterUnauthorizedDatalakeTableNames({
        authorizedTableNames,
        requestedTableNames,
    });
    return unauthorizedDatalakeTableNames;
};
exports.filterUnauthorizedDatalakeTableNames = filterUnauthorizedDatalakeTableNames;
const _isFormula = (input) => {
    return typeof input === 'string' && input.startsWith('=');
};
const countPositionalBindings = (query) => {
    return (query.match(/\?/g) || []).length;
};
// does static validation on query and bindings.
// at this point we do not have variable values.
// checks:
// 1) all bindings are valid ( only available variables are referenced)
// 2) have correct number of bindings.
// @waitForDataLake: add more validation checks for query itself.
const staticValidateQuery = (params) => {
    const { availableVariables, bindings, query } = params;
    const errors = [];
    for (const binding of bindings) {
        if (_isFormula(binding)) {
            const formula = binding.slice(1);
            const formulaErrors = (0, formula_engine_1.getFormulaErrors)(formula, availableVariables);
            if (formulaErrors.errorMessages.length > 0) {
                formulaErrors.errorMessages.forEach((err) => errors.push(err));
            }
        }
        else {
            errors.push(`bindings must start with "=": [binding:${binding}]`);
        }
    }
    // ensure that query has same number of ? as bindings
    const numBindings = bindings.length;
    const expectedBindings = countPositionalBindings(query);
    if (numBindings !== expectedBindings) {
        errors.push(`Number of bindings does not match number of question marks in query: [numBindings:${numBindings}, expectedBindings:${expectedBindings}]`);
    }
    if (errors.length > 0) {
        return { isValid: false, errors };
    }
    return { isValid: true };
};
exports.staticValidateQuery = staticValidateQuery;
const validateAthenaQuery = ({ query, bindings, variables, }) => {
    try {
        const errors = [];
        if (query === '') {
            errors.push('Athena query string is empty');
            return errors;
        }
        // checks for dup variables, pass variables to formula bindings, evaluate formula bindings,
        // attach binding to query
        const queryStringResult = (0, construct_1.constructSqlQueryString)({
            query,
            bindings,
            variables,
        });
        if (!queryStringResult.isValid) {
            return queryStringResult.errors;
        }
        // validate query syntax
        // TODO - find presto / trino parser that validate our athena query syntax sync
        // failed packages:
        //  - node-sql-parser (and several others that failed during initial selection)
        // validate query against forbidden keywords
        const res = common_1.datalake.athena.validateForbiddenSqlString(queryStringResult.queryString);
        variables.forEach(({ name: variableName }) => {
            if (variableName === '') {
                errors.push(`Athena query variable name is empty. Athena Query: ${query}`);
            }
        });
        if (!res.isValid) {
            errors.push(res.errorMessage);
        }
        return errors;
    }
    catch (err) {
        return utils.handleError({
            err,
            prefix: `Error during validateAthenaQuery. Athena Query: ${query}.`,
        });
    }
};
exports.validateAthenaQuery = validateAthenaQuery;
const validateAthenaQueries = (queries) => {
    const errors = [];
    const queryNameSet = new Set();
    const queryResultVariablesSet = new Set();
    queries.forEach((query) => {
        const { query: { queryString, name: queryName }, variables, bindings, columnNames, } = query;
        if (queryName === '') {
            errors.push(`Athena Query name is empty.`);
        }
        if (queryNameSet.has(queryName)) {
            errors.push(`Duplicate Athena query name detected: ${queryName}`);
        }
        else {
            queryNameSet.add(queryName);
        }
        if (!columnNames.length) {
            errors.push(`Athena Query ${queryName} column names have not been set.`);
        }
        columnNames.forEach((columnName) => {
            const queryResultVariable = `${queryName}.${columnName}`;
            if (queryResultVariablesSet.has(queryResultVariable)) {
                errors.push(`Detected duplicate Athena Query result variable ${queryResultVariable}.`);
            }
            else {
                queryResultVariablesSet.add(queryResultVariable);
            }
        });
        // validates variables, formula bindings, # of bindings, query syntax
        const queryErrors = (0, exports.validateAthenaQuery)({
            query: queryString,
            bindings,
            variables,
        });
        queryErrors.forEach((err) => errors.push(err));
    });
    return { errors, queryResultVariables: Array.from(queryResultVariablesSet) };
};
exports.validateAthenaQueries = validateAthenaQueries;
//# sourceMappingURL=athenaValidate.js.map